export default __webpack_public_path__ + "postMock-1747325621234.html";